import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { LIBRARY_FILTER } from 'Pods/ThreeDStudio/Store/constants'

import FilteringRadio from './Components/FilteringRadio/FilteringRadio'

function SubItems() {
  const t = useTranslation()

  return (
    <div className="filtering-content__sub-items">
      <FilteringRadio
        id="filtering-content-all"
        keyName={LIBRARY_FILTER.GENERATED_ALL}
        label={t('sidebar.filtering.all')}
      />
      <FilteringRadio
        id="filtering-content-favorites"
        keyName={LIBRARY_FILTER.GENERATED_FAVORITES}
        label={t('sidebar.filtering.favorites')}
      />
      <FilteringRadio
        id="filtering-content-drafts"
        keyName={LIBRARY_FILTER.GENERATED_DRAFTS}
        label={t('sidebar.filtering.drafts')}
      />
    </div>
  )
}

export default memo(SubItems)
